export const PATH = {
  signUp: 'signup',
  signIn: 'signin',
  todo: 'todo',
} as const;
